import React from 'react';

const BlogLink = (props) => {
    return (
        <div>
            <p>
                集計方法は

                <a href={props.link} target="_blank" rel="noopener noreferrer">
                    こちら
                </a>
            </p>
        </div>
    );
};

export default BlogLink;
